export enum RouteName {
  PJD_Home = "PJD_Home",
  PJD_Login = "PJD_Login",
  PJD_Settings = "PJD_Settings",
  PJD_DashboardHome = "PJD_DashboardHome",
  PJD_InconsoleMessageAdd = "PJD_InconsoleMessage_Add",
  PJD_InconsoleMessageList = "PJD_InconsoleMessage_List",
  PJD_AddCreditCardShipment = "PJD_AddCreditCardShipment",
  PJD_CreditCardShipmentAddressTesting = "PJD_CreditCardShipmentAddressTesting",
  PJD_MarkShipmentAsDelivered = "PJD_MarkShipmentAsDelivered",
  PJD_DetailedTransactions = "PJD_DetailedTransactions",
  PJD_BulkCardDisablingTool = "PJD_BulkCardDisablingTool",
  PJD_OperationHours = "PJD_OperationHours",
  PJD_ShipmentConfigurationTool = "PJD_ShipmentConfigurationTool",
}
